import { HelpVideo } from '../../../app/core/help/HelpVideo';

export const LegacyBoardsHaug = HelpVideo(
    'LegacyBoardsHaug',
    'Dashboard / Views',
    'Legacy Boards',
    2010,
    'https://s.ludi.co/app/haug/02040-legacy-boards.mp4',
);
